import { render, staticRenderFns } from "./AnularFE.vue?vue&type=template&id=272738e0"
import script from "./AnularFE.vue?vue&type=script&lang=js"
export * from "./AnularFE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports